import React, { useEffect, useState } from 'react'
import SVG from "react-inlinesvg";
import { useParams } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import { verifyUserUrl } from '../../../common-url/CommonUrl';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from "react-router-dom";

export default function UserVerified() {

    useEffect(() => {
        verifyUser()

    }, [])
    const [code, setCode] = useState()
    const [fullname, setFullname] = useState()

    let { id } = useParams();

    const verifyUser = async () => {
        await fetch(verifyUserUrl + `/verify-account/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
                setCode(response.code)
                if (response.code == 200 || response.code == 201) {
                    setFullname(response.data.vFullName)
                } else {
                    setFullname("")
                }
                // console.log(response, "response.......")
                // console.log(response.data.vFullName, "full name...........")
                // if (response.data.vFullName) {
                //     setFullname(response.data.vFullName)
                // }
                // console.log(response.data.vFullName, "response...........")
            });
    }

    if (code == 200) {
        return (
            <>
                <div className=" row text-center">
                    <label className="text-dark col-form-label">
                        <h4 className="display-4 font-weight-bolder">Activation Complete!</h4>
                    </label>

                    <div className=" col-sm-4 offset-sm-4 mt-10">
                        <div className="svg-icon svg-icon-3x svg-icon-success rounded-circle border border-success svg-verified">
                            <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")} />
                        </div>
                    </div>
                    <label className="text-dark font-weight-bolder my-10">
                        <h4 className="display-4">Hello {fullname ? (fullname) : ("")}..!</h4>
                    </label>
                    <h5 className="text-center d-flex flex-column">
                        <span className="font-weight-bolder font-size-lg text-dark-75 lh-base">Your Account has been successfully activated.</span>
                        <span className="font-weight-mormal font-size-lg text-muted lh-base">You can now log in using the username and password you chose during the registration.</span>
                    </h5>
                  {/*  <Link to="/auth">
                        <button className="btn btn-light-primary font-weight-bold mt-8 btn-lg col-sm-1 mx-auto">Login</button>
                    </Link>*/}
                </div>
            </>
        )
    } else if (code == 201) {
        return (
            <>
                <div className=" row text-center mt-n20">
                    <label className="text-dark col-form-label">
                        <h4 className="display-4 font-weight-bolder">Already Activated...</h4>
                    </label>
                    <div className=" col-sm-4 offset-sm-4 mt-10">
                        <div className="svg-icon svg-icon-3x svg-icon-warning rounded-circle border border-warning svg-verified">
                            <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")} />
                        </div>
                    </div>
                    <label className="text-dark font-weight-bolder my-10">
                        <h4 className="display-4">Hello {fullname ? (fullname) : ("")}..!</h4>
                    </label>
                    <h5 className="text-center d-flex flex-column">
                        <span className="font-weight-bolder font-size-lg text-dark-75 lh-base">Your Account has been already activated.</span>
                        <span className="font-weight-mormal font-size-lg text-muted lh-base">You can now log in using the username and password you chose during the registration.</span>
                    </h5>
                    {/*<Link to="/auth">
                        <button className="btn btn-light-primary font-weight-bold mt-8 btn-lg col-sm-1 mx-auto">Login</button>
                    </Link>*/}
                </div>
            </>
        )
    } else if (code == 401) {
        return (
            <>
                <div className=" row text-center mt-n20">
                    <label className="text-dark col-form-label">
                        <h4 className="display-4 font-weight-bolder">Invalid Link...</h4>
                    </label>
                    <div className=" col-sm-4 offset-sm-4 mt-10">
                        <div className="svg-icon svg-icon-3x svg-icon-danger rounded-circle border border-danger svg-verified">
                            <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Warning-1-circle.svg")} />
                        </div>
                    </div>
                    <label className="text-dark font-weight-bolder my-10">
                        <h4 className="display-4">Hello..!</h4>
                    </label>
                    <h5 className="text-center d-flex flex-column">
                        <span className="font-weight-bolder font-size-lg text-dark-75 lh-base">Your Activation Link is Invalid.</span>
                        <span className="font-weight-mormal font-size-lg text-muted lh-base">You need to avtivate your account again.</span>
                    </h5>
                </div>
            </>)
    }
    else {
        return (
            <>
                <CircularProgress disableShrink />
            </>
        )
    }
}
